import React, {
  Children, ReactElement, useEffect, useState,
} from 'react';

export enum ContentBlockModifier {
  MAIN = 'main',
  SUB = 'sub',
  NO_MARGIN = 'noMargin',
  OLD = 'old',
}

export interface ContentBlockProps {
  modifiers?: ContentBlockModifier[];
  title: string | React.ReactElement;
  desc?: string;
  children?: React.ReactElement | React.ReactElement[];
}

function ContentBlock(props: ContentBlockProps) {
  const {
    modifiers, title, desc, children,
  } = props;

  const [mods, setMods] = useState('');
  const [actionSlot, setActionSlot] = useState<ReactElement | undefined>(undefined);
  const [contentSlot, setContentSlot] = useState<ReactElement | undefined>(undefined);

  useEffect(() => {
    if (props.modifiers) {
      setMods(props.modifiers.map((_modifier: ContentBlockModifier) => `_${_modifier} `).join(''));
    }
  }, [props.modifiers]);

  useEffect(() => {
    if (children) {
      const arrayChildren = Children.toArray(children);

      arrayChildren.forEach((child) => {
        if ((child as ReactElement).key === '.$actions') {
          setActionSlot(child as ReactElement);
        } else {
          setContentSlot(child as ReactElement);
        }
      });
    }
  }, [children]);

  return (
    <div className={`ct_contentBlock ${mods}`}>
      <div className="ct_contentBlock-head">
        <div className="ct_contentBlock-header">
          {title && (
          <div className="ct_contentBlock-title">
            {modifiers?.includes(ContentBlockModifier.MAIN) && (<h2 className="ct_h3">{title}</h2>)}
            {modifiers?.includes(ContentBlockModifier.SUB) && (<h2 className="ct_subtitle1">{title}</h2>)}
          </div>
          )}
          {desc && (
          <div className="ct_contentBlock-desc">
            {modifiers?.includes(ContentBlockModifier.MAIN) && (<p className="ct_body2">{desc}</p>)}
            {modifiers?.includes(ContentBlockModifier.SUB) && (<p className="ct_body3">{desc}</p>)}
          </div>
          )}
        </div>
        {!!actionSlot && (
          <div className="ct_contentBlock-actions">
            {actionSlot}
          </div>
        )}
      </div>
      {children && (
        <div className="ct_contentBlock-content">
          {contentSlot}
        </div>
      )}
    </div>
  );
}

ContentBlock.defaultProps = { ...{} };

export default ContentBlock;
